<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>
          {{ $t('Juridinio fakto „Šeimos turtas“ išregistravimo pagrindas') }}
        </h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-2">
          <v-card-text>
            <el-overlay-loading :loading="pageloading" />
            <v-row>
              <v-col cols="12" md="8">
                <el-radio-group
                  class="my-0"
                  required
                  itemvalue="value"
                  itemtext="text"
                  validate-key="pagrindasId"
                  hide-details="auto"
                  :items="pagrindasList"
                  v-model="pagrindasId"
                  inline
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          {{ $t('Atšaukti') }}
        </el-button>
        <el-button
          primary
          @click.native.stop="saveData()"
          :disabled="disableSave"
        >
          {{ $t('Tęsti') }}
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalNtrPrasymasPagrindas',
  props: {
    prasymasTipasFilter: String,
    value: Boolean,
  },
  data() {
    return {
      pagrindai: [],
      pagrindasId: null,
      roleObjekte: null,
      pageloading: true,
      loading: false,
    }
  },
  computed: {
    disableSave() {
      return this.pagrindasId === null
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    pagrindasList() {
      return this.pagrindai.map(pagrindas => {
        pagrindas.label = this.$t(pagrindas.text)
        pagrindas.tooltip = `NtrPaslaugos. Šeima išregistravimas. ${pagrindas.text}`

        return pagrindas
      })
    },
  },
  created() {
    this.pageloading = true
    this.loading = false
    this.getData()
  },
  methods: {
    getData() {
      const data = {
        klasifikatoriai: ['isregistravimo_pagrindai_seima'],
      }
      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.pagrindai = res.data.list.isregistravimo_pagrindai_seima
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
    },

    saveData() {
      this.$emit('confirmPrasymasPagrindas', this.pagrindasId)
      this.closeModal()
    },
    cancelData() {
      this.$emit('cancelPrasymasPagrindas')
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.cancelData()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
